<div class="scale-slider">
    <ngx-slider [attr.id]="sliderId" [formControl]="sliderControl" [options]="sliderOptions" (userChange)="onUserChange($event)" [class.has-error]="question.hasError"></ngx-slider>

    <div class="scale-label" *ngIf="question?.scaleOption?.label">
        <div>{{question?.scaleOption?.label.start}}</div>
        <div>{{question?.scaleOption?.label.end}}</div>
    </div>
</div>
